import { isPlatformBrowser, NgForOf, NgStyle } from '@angular/common';
import { Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Component, Input, signal } from '@angular/core';

@Component({
    selector: 'vsf-usp-bar',
    templateUrl: './usp-bar.component.html',
    styleUrl: './usp-bar.component.css',
    standalone: true,
    imports: [NgForOf, NgStyle],
})
export class UspBarComponent implements OnInit, OnDestroy {
    @Input() items: string[] = ['Price match promise', 'Free delivery over £25', 'Rated \'Excellent\' on Trustpilot'];
    currentIndex = signal(0);
    private intervalId: number | undefined;

    constructor(@Inject(PLATFORM_ID) private platformId: any) {}

    ngOnInit(): void {
        // Only set up the interval if running in the browser
        if (isPlatformBrowser(this.platformId)) {
            this.intervalId = window.setInterval(() => {
                this.next();
            }, 3000);
        }
    }

    ngOnDestroy(): void {
        // Clear the interval to prevent memory leaks
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

    next() {
        this.currentIndex.set((this.currentIndex() + 1) % this.items.length);
    }
}
